import type { CellTemplateProp, HyperFunc, VNode } from '@revolist/react-datagrid';

import { RevoGridTableExtras } from './types';

/** 
 * path from src/assets/icons/EditIcon.tsx (hyperscript instead of react component to improve performance and avoid unneeded
 * buildup/teardown each render since revogrid uses virtualization for performance
)*/
const EDIT_ICON_PATH =
  'M3 17.4601V20.5001C3 20.7801 3.22 21.0001 3.5 21.0001H6.54C6.67 21.0001 6.8 20.9501 6.89 20.8501L17.81 9.94006L14.06 6.19006L3.15 17.1001C3.05 17.2001 3 17.3201 3 17.4601ZM20.71 7.04006C21.1 6.65006 21.1 6.02006 20.71 5.63006L18.37 3.29006C17.98 2.90006 17.35 2.90006 16.96 3.29006L15.13 5.12006L18.88 8.87006L20.71 7.04006Z';

/**
 * A single pencil-icon button, centered in the cell. Fires `extra.onEditRow`
 * with the row's `id`: the same `additionalData` channel the dropdown
 * columns use to open their editor, since a cell template cannot close over
 * React state directly.
 */
export const editButtonCellTemplate = (
  h: HyperFunc<VNode>,
  props: CellTemplateProp,
  extra?: RevoGridTableExtras
) =>
  h(
    'span',
    {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
      },
    },
    h(
      'span',
      {
        role: 'button',
        'aria-label': 'Edit tag',
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: extra?.field?.icon ?? 'currentColor',
        },
        // do not let the icon start a range drag
        onMouseDown: (event: MouseEvent) => event.stopPropagation(),
        onClick: (event: MouseEvent) => {
          event.stopPropagation();
          const rowId = (props.model as { id?: string } | undefined)?.id;
          if (rowId) {
            extra?.onEditRow?.(rowId);
          }
        },
      },
      h(
        'svg',
        { width: '18', height: '18', viewBox: '0 0 24 24', 'aria-hidden': 'true' },
        h('path', { fill: 'currentColor', d: EDIT_ICON_PATH })
      )
    )
  );
